import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { updateBatchTargetStatus } from '../SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
import { CancelButton } from '../../../../../components/buttons';
import SmallLoader from '../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from "../../../../../components/reduxFields";
// import validate from './validate';

class UpdateBatchTargetStatusModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            selectedSkillsAcquisitionTargetIds: this.props.selectedSkillsAcquisitionTargetIds.length > 0 ? this.props.selectedSkillsAcquisitionTargetIds : []
        };
    }

    handleClose = () => {
        this.props.closeDialog();
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleNewRequest(input, selectedValue) {
        input.onChange(selectedValue.value);
        this.props.updateBatchTargetStatus(this.state.selectedSkillsAcquisitionTargetIds, selectedValue.value, this.props.patientId, this.props.skillsAcquisitionProgramId);
        this.setState({ open: false });
        this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        ];
        return (
            <Dialog
                className="custom_modal"
                title="Update Batch Target Status"
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form">
                            <div className="row">
                                <div className="col-sm-12 require" style={{ marginTop: '50px' }}>
                                    <Field
                                        name={`targetStatusId`}
                                        hintText="Status"
                                        handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                                        options={this.props.masterTargetStatusWithoutReady}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Dialog>
        );
    }
}

UpdateBatchTargetStatusModal = reduxForm({
    form: 'UpdateBatchTargetStatusModalForm',
    // validate,
    enableReinitialize: true,
})(UpdateBatchTargetStatusModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: false 
    }
}

export default connect(mapStateToProps, {updateBatchTargetStatus})(UpdateBatchTargetStatusModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/UpdateBatchTargetStatusModal.js